import {
  GET_LANGUAGE_LİST_ERROR,
  GET_LANGUAGE_LİST_SUCCESS,
  LanguageList,
  UserDetail,
  memberActions,
  CostCenter,
  Companies,
  GET_COMPANIES_SUCCESS,
  CustomerList,
  PassiveCustomerList,
  GET_COMPANIES_ERROR,
  CurrentDebt,
  GET_MY_USER_DETAIL_SUCCESS,
  GET_MY_USER_DETAIL_ERROR,
  MainCostCenter,
  SubCostCenter,
  CostCenterList,
  CostCenterDetail,
  Firm,
  StartingWorkEmployees,
  PersonalTypeList,
  TechnoparkNameList,
  PersonnelNameForProjectAssignmentList,
  ProjectNameList,
  TeknoparkList,
  ProjectAssignmentList,
  GET_ALL_CUSTOMER_SUCCESS,
  GET_ALL_CUSTOMER_ERROR,
  GET_ALL_PASSIVE_CUSTOMER_ERROR,
  GET_ALL_PASSIVE_CUSTOMER_SUCCESS,
  LeavingPersonalList,
  GET_ALL_PERSONNEL_LİST_SUCCESS,
  GET_ALL_PERSONNEL_LİST_ERROR,
  GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS,
  GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR,
  RelatedMemberNameList,
  TeknoparkUpdateList,
  AllTechnoparkNameList,
  GET_PROJECT_DETAIL_SUCCESS,
  GET_PROJECT_DETAIL_ERROR,
  GET_INSOURCE_PERSONAL_SUCCESS,
  GET_INSOURCE_PERSONAL_ERROR,
  GET_FILTER_SECTION_PROJECT_INFO_SUCCESS,
  GET_FILTER_SECTION_PROJECT_INFO_ERROR,
  GET_PROJECT_CLOSING_REPORT_SUCCESS,
  GET_PROJECT_CLOSING_REPORT_ERROR,
  LanguageLevelList,
  GET_LANGUAGE_LEVEL_LİST_SUCCESS,
  GET_LANGUAGE_LEVEL_LİST_ERROR,
  CountryList,
  GET_COUNTRY_LİST_SUCCESS,
  GET_COUNTRY_LİST_ERROR,
  CityList,
  GET_CITY_LİST_SUCCESS,
  GET_CITY_LİST_ERROR,
  TownList,
  GET_TOWN_LİST_BY_CITY_SUCCESS,
  GET_TOWN_LİST_BY_CITY_ERROR,
  CollageList,
  GET_COLLAGE_LİST_SUCCESS,
  GET_COLLAGE_LİST_ERROR,
  DepartmentList,
  GET_DEPARTMENT_LİST_SUCCESS,
  GET_DEPARTMENT_LİST_ERROR,
  PersonalCommunicationLevelList,
  GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS,
  GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR,
  GraduationStatusList,
  GET_GRADUATION_STATUS_LIST_SUCCESS,
  GET_GRADUATION_STATUS_LIST_ERROR,
  MilitaryServiceStatusList,
  GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS,
  GET_MILITARY_SERVICE_STATUS_LIST_ERROR,
  DriversLicenseList,
  GET_DRIVERS_LICENSE_LIST_SUCCESS,
  GET_DRIVERS_LICENSE_LIST_ERROR,
  TechnicList,
  GET_TECHNIC_LIST_SUCCESS,
  GET_TECHNIC_LIST_ERROR,
  PersonalAbilityList,
  GET_PERSONAL_ABİLİTY_LİST_SUCCESS,
  GET_PERSONAL_ABİLİTY_LİST_ERROR,
  CommunicationParameterList,
  GET_COMMUNICATION_PARAMETER_LIST_SUCCESS,
  GET_COMMUNICATION_PARAMETER_LIST_ERROR,
  PositionList,
  GET_POSITION_LIST_SUCCESS,
  GET_POSITION_LIST_ERROR,
  PositionListByCompany,
  GET_POSITION_LIST_BY_COMPANY_SUCCESS,
  GET_POSITION_LIST_BY_COMPANY_ERROR,
  GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS,
  GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR,
  PositionListTechnicGroup,
  PositionListByProject,
  GET_POSITION_LIST_BY_PROJECT_SUCCESS,
  GET_POSITION_LIST_BY_PROJECT_ERROR,
  GET_NAV_CANDIDATE_SEARCH_SUCCESS,
  GET_NAV_CANDIDATE_SEARCH_ERROR,
  NavCandidateListItem,
  GET_TECHNİC_GROUP_MAİN_LİST_ERROR,
  GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS,
  TechnicalList,
  GET_ALL_TECHNICAL_GROUP_SUCCESS,
  GET_ALL_TECHNICAL_GROUP_ERROR,
  TechnicGroupMainList,
  GET_ALL_VERSIONS_SUCCESS,
  GET_ALL_VERSIONS_ERROR,
} from "../../redux/actions/actionTypes";


interface CostCenterState {
  costCenterList: CostCenter[];
  message: string;
}

const initialStateCustomerList: CustomerListState = {
  customerList: [],
  message: ""
}



 interface CustomerListState {
  customerList: CustomerList[];
  message: string
}


interface CompaniesState {
  companiesList: Companies[];
  message: string;
}

interface CustomersState {
  customerList: CustomerList[];
  message: string;
}
interface PassiveCustomersState {
  passiveCustomerList: PassiveCustomerList[];
  message: string;
}

const initialStateCompanies: CompaniesState = {
  companiesList: [],
  message: "",
};
const initialStateCustomers: CustomersState = {
  customerList: [],
  message: "",
};
const initialStatePassiveCustomers: PassiveCustomersState = {
  passiveCustomerList: [],
  message: "",
};

interface CurrentDebtState {
  currentDebtList: CurrentDebt[];
  message: string;
}

interface MyUserDetailListState {
  myUserDetailList: UserDetail[];
  message: string;
}

const initialStateMyUserDetail: MyUserDetailListState = {
  myUserDetailList: [],
  message: "",
};

// Versions (Release Notes) State
interface VersionsState {
  versions: any[];
  message: string;
}

const initialStateVersions: VersionsState = {
  versions: [],
  message: "",
};

interface MainCostCenterState {
  mainCostCenterList: MainCostCenter[];
  message: string;
}

interface SubCostCenterState {
  subCostCenterList: SubCostCenter[];
  message: string;
}

interface CostCenterListState {
  costAllCenterList: CostCenterList[];
  message: string;
}

interface CostCenterDetailState {
  costCenterDetail: CostCenterDetail[];
  message: string;
}

interface FirmState {
  firm: Firm[];
  message: string;
}

interface StartingWorkEmployeesState {
  startingWorkEmployees: StartingWorkEmployees[] | undefined;
  message: string;
}

interface TechnoparkNameListState {
  technoparkNameList: TechnoparkNameList[];
  message: string;
}

interface PersonnelNameForProjectAssignmentListState {
  personnelNameForProjectAssignmentList: PersonnelNameForProjectAssignmentList[];
  message: string;
}

interface RelatedMemberNameListState {
  relatedMemberNameList: RelatedMemberNameList[];
  message: string;
}

interface PersonalTypeListState {
  personalTypeList: PersonalTypeList[];
  message: string;
}

interface ProjectNameListState {
  projectNameList: ProjectNameList[];
  message: string;
}

interface TeknoparkListState {
  teknoparkList: TeknoparkList[];
  message: string;
}

interface TeknoparkUpdateState {
  teknoparkUpdateList: TeknoparkUpdateList[];
  message: string;
}

interface ProjectAssignmentListState {
  projectAssignmentList: ProjectAssignmentList[];
  message: string;
}

interface LeavingPersonalListState {
  leavingPersonalList: LeavingPersonalList[];
  message: string;
}

interface AllTechnoparkNameListState {
  allTechnoparkNameList: AllTechnoparkNameList[];
  message: string;
}

interface BarChartState {
  barChartData: any;
  message: string;
}

interface PieChartState {
  pieChartData: any;
  message: string;
}

interface TeknoparkDetailState {
  teknoparkDetail: any;
  message: string;
}

interface ProjectDetailState {
  projectDetail: any;
  message: string;
}

const initialStateProjectDetail: ProjectDetailState = {
  projectDetail: null,
  message: "",
};

interface ProjectStatusParameterState {
  projectStatusParameter: any;
  message: string;
}

interface CapacityInfoState {
  capacityInfo: any;
  message: string;
}

interface TeknoparkInfoState {
  teknoparkInfo: any;
  message: string;
}

interface TeknoparkAndProjectInfoState {
  teknoparkAndProjectInfo: any[];
  message: string;
}

interface ProjectPersonnelSalaryState {
  projectPersonnelSalary: any;
  message: string;
}

interface InsourcePersonalState {
  data: any[];
  error: string | null;
}

const initialStateInsourcePersonal: InsourcePersonalState = {
  data: [],
  error: null,
};

interface TechnoparkProjectTableInfoState {
  technoparkProjectTableInfo: any[];
  message: string;
}

interface FilterSectionProjectInfoState {
  filterSectionProjectInfo: any[];
  message: string;
}

const initialStateFilterSectionProjectInfo: FilterSectionProjectInfoState = {
  filterSectionProjectInfo: [],
  message: "",
};

interface TechnoparkState {
  technopark: any;
  message: string;
}

const initialState = {
  insourcePersonal: {
    data: [],
    error: null,
  },
};

const initialStateProjectClosingReport = {
  projectClosingReport: null,
  message: ""
};

interface RentReminderNotificationsState {
  notifications: any[];
  loading: boolean;
  message: string;
}


interface TechnicGroupMainListState {
  technicGroupMainList: TechnicGroupMainList[];
  message: string
}

const initialStateTechnicGroupMainList: TechnicGroupMainListState = {
  technicGroupMainList: [],
  message: ""
}

interface TechnicalGroupState {
  technicalList: TechnicalList[];
  message: string
}
const initialStateTechnicalGroup: TechnicalGroupState = {
  technicalList: [],
  message: ""
}

interface TechnicalListState {
  technicalList: TechnicalList[];
  message: string;
}

interface PositionListingByProjectState {
  positionListByProject: PositionListByProject[];
  message: string
}

const initialStatePositionListingByProject: PositionListingByProjectState = {
  positionListByProject: [],
  message: ""
}


interface PositionListState {
  positionList: PositionList[];
  message: string
}

const initialStatePositionList: PositionListState = {
  positionList: [],
  message: ""
}


interface PositionListByTechnicGroupState {
  positionListByTechnicGroup: PositionListTechnicGroup[];
  message: string
}

const initialStatePositionListByTechnicGroup: PositionListByTechnicGroupState = {
  positionListByTechnicGroup: [],
  message: ""
}

interface PositionListingByCompanyState {
  positionListByCompany: PositionListByCompany[];
  messagePositionListByCompany: string
}

const initialStatePositionListingByCompany: PositionListingByCompanyState = {
  positionListByCompany: [],
  messagePositionListByCompany: ""
}

interface NavCandidateSearchState {
  navCandidateSearchList: NavCandidateListItem[];
  message: string;
}

const initialStateNavCandidateSearch: NavCandidateSearchState = {
  navCandidateSearchList: [],
  message: "",
};

export function customerListReducer(
  state: CustomerListState = initialStateCustomerList,
  action: memberActions,
): CustomerListState {
  switch (action.type) {
    case GET_ALL_CUSTOMER_SUCCESS: {
      return {
        ...state,
        customerList: action.payload,
      };
    }
    case GET_ALL_CUSTOMER_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function technicGroupMainListReducer(
  state: TechnicGroupMainListState = initialStateTechnicGroupMainList,
  action: memberActions,
): TechnicGroupMainListState {
  switch (action.type) {
    case GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS: {
      return {
        ...state,
        technicGroupMainList: action.payload,
      };
    }
    case GET_TECHNİC_GROUP_MAİN_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function technicalReducer(
  state: TechnicalGroupState = initialStateTechnicalGroup,
  action: memberActions,
): TechnicalGroupState {
  switch (action.type) {
    case GET_ALL_TECHNICAL_GROUP_SUCCESS: {
      return {
        ...state,
        technicalList: action.payload,
      };
    }
    case GET_ALL_TECHNICAL_GROUP_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}



export function positionListReducer(
  state: PositionListState = initialStatePositionList,
  action: memberActions,
): PositionListState {
  switch (action.type) {
    case GET_POSITION_LIST_SUCCESS: {
      return {
        ...state,
        positionList: action.payload,
      };
    }
    case GET_POSITION_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function positionListByProjectReducer(
  state: PositionListingByProjectState = initialStatePositionListingByProject,
  action: memberActions,
): PositionListingByProjectState {
  switch (action.type) {
    case GET_POSITION_LIST_BY_PROJECT_SUCCESS: {
      return {
        ...state,
        positionListByProject: action.payload,
      };
    }
    case GET_POSITION_LIST_BY_PROJECT_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function positionListByTechnicGroupReducer(
  state: PositionListByTechnicGroupState = initialStatePositionListByTechnicGroup,
  action: memberActions,
): PositionListByTechnicGroupState {
  switch (action.type) {
    case GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS: {
      return {
        ...state,
        positionListByTechnicGroup: action.payload,
      };
    }
    case GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function positionListByCompanyReducer(
  state: PositionListingByCompanyState = initialStatePositionListingByCompany,
  action: memberActions,
): PositionListingByCompanyState {
  switch (action.type) {
    case GET_POSITION_LIST_BY_COMPANY_SUCCESS: {
      return {
        ...state,
        positionListByCompany: action.payload,
      };
    }
    case GET_POSITION_LIST_BY_COMPANY_ERROR: {
      return {
        ...state,
        messagePositionListByCompany: action.payload,
      };
    }
    default:
      return state;
  }
}

export function navCandidateSearchReducer(
  state: NavCandidateSearchState = initialStateNavCandidateSearch,
  action: memberActions,
): NavCandidateSearchState {
  switch (action.type) {
    case GET_NAV_CANDIDATE_SEARCH_SUCCESS: {
      return {
        ...state,
        navCandidateSearchList: action.payload,
      };
    }
    case GET_NAV_CANDIDATE_SEARCH_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}



export function companiesReducer(
  state: CompaniesState = initialStateCompanies,
  action: memberActions
): CompaniesState {
  switch (action.type) {
    case GET_COMPANIES_SUCCESS: {
      return {
        ...state,
        companiesList: action.payload,
      };
    }
    case GET_COMPANIES_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}
export function customersReducer(
  state: CustomersState = initialStateCustomers,
  action: memberActions
): CustomersState {
  switch (action.type) {
    case GET_ALL_CUSTOMER_SUCCESS: {
      return {
        ...state,
        customerList: action.payload,
      };
    }
    case GET_ALL_CUSTOMER_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function passiveCustomerReducer(
  state: PassiveCustomersState = initialStatePassiveCustomers,
  action: memberActions
): PassiveCustomersState {
  switch (action.type) {
    case GET_ALL_PASSIVE_CUSTOMER_SUCCESS: {
      return {
        ...state,
        passiveCustomerList: action.payload,
      };
    }
    case GET_ALL_PASSIVE_CUSTOMER_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

export function myUserDetailReducer(
  state: MyUserDetailListState = initialStateMyUserDetail,
  action: memberActions
): MyUserDetailListState {
  switch (action.type) {
    case GET_MY_USER_DETAIL_SUCCESS: {
      return {
        ...state,
        myUserDetailList: action.payload,
      };
    }
    case GET_MY_USER_DETAIL_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Versions (Release Notes) Reducer
export const versionsReducer = (
  state: VersionsState = initialStateVersions,
  action: memberActions
): VersionsState => {
  switch (action.type) {
    case GET_ALL_VERSIONS_SUCCESS:
      return {
        ...state,
        versions: action.payload,
        message: "",
      };
    case GET_ALL_VERSIONS_ERROR:
      return {
        ...state,
        versions: [],
        message: action.payload,
      };
    default:
      return state;
  }
};

export function projectDetailReducer(
  state: ProjectDetailState = initialStateProjectDetail,
  action: memberActions
): ProjectDetailState {
  switch (action.type) {
    case GET_PROJECT_DETAIL_SUCCESS: {
      return {
        ...state,
        projectDetail: action.payload,
      };
    }
    case GET_PROJECT_DETAIL_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

interface TeknoparkProjectsState {
  projects: any[];
  message: string;
}

export const insourcePersonalReducer = (
  state = initialStateInsourcePersonal,
  action: memberActions
): InsourcePersonalState => {
  switch (action.type) {
    case GET_INSOURCE_PERSONAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case GET_INSOURCE_PERSONAL_ERROR:
      return {
        ...state,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export const memberListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_INSOURCE_PERSONAL_SUCCESS:
      return {
        ...state,
        insourcePersonal: {
          data: action.payload,
          error: null,
        },
      };
    case GET_INSOURCE_PERSONAL_ERROR:
      return {
        ...state,
        insourcePersonal: {
          data: [],
          error: action.payload,
        },
      };
  }
};

export const filterSectionProjectInfoReducer = (
  state = initialStateFilterSectionProjectInfo,
  action: memberActions
): FilterSectionProjectInfoState => {
  switch (action.type) {
    case GET_FILTER_SECTION_PROJECT_INFO_SUCCESS:
      return {
        ...state,
        filterSectionProjectInfo: action.payload
      };
    case GET_FILTER_SECTION_PROJECT_INFO_ERROR:
      return {
        ...state,
        message: action.payload
      };
    default:
      return state;
  }
};

export const projectClosingReportReducer = (
  state = initialStateProjectClosingReport,
  action: memberActions
) => {
  switch (action.type) {
    case GET_PROJECT_CLOSING_REPORT_SUCCESS:
      return {
        ...state,
        projectClosingReport: action.payload
      };
    case GET_PROJECT_CLOSING_REPORT_ERROR:
      return {
        ...state,
        message: action.payload
      };
    default:
      return state;
  }
};

// All Personnel State and Reducer
interface AllPersonnelState {
  personnelAllList: any;
  message: string;
}

const initialStateAllPersonnel: AllPersonnelState = {
  personnelAllList: null,
  message: ""
};

export const allPersonnelReducer = (
  state = initialStateAllPersonnel,
  action: memberActions
): AllPersonnelState => {
  switch (action.type) {
    case GET_ALL_PERSONNEL_LİST_SUCCESS:
      return {
        ...state,
        personnelAllList: action.payload,
        message: ""
      };
    case GET_ALL_PERSONNEL_LİST_ERROR:
      return {
        ...state,
        personnelAllList: null,
        message: action.payload
      };
    default:
      return state;
  }
};

// All Member List For Position State and Reducer
interface AllMemberListForPositionState {
  allMemberListForPosition: any;
  message: string;
}

const initialStateAllMemberListForPosition: AllMemberListForPositionState = {
  allMemberListForPosition: null,
  message: ""
};

export const allMemberListForPositionReducer = (
  state = initialStateAllMemberListForPosition,
  action: memberActions
): AllMemberListForPositionState => {
  switch (action.type) {
    case GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS:
      return {
        ...state,
        allMemberListForPosition: action.payload,
        message: ""
      };
    case GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR:
      return {
        ...state,
        allMemberListForPosition: null,
        message: action.payload
      };
    default:
      return state;
  }
};

// Language Level List State and Reducer
interface LanguageLevelListState {
  languageLevelList: LanguageLevelList[];
  message: string
}

const initialStateLanguageLevelList: LanguageLevelListState = {
  languageLevelList: [],
  message: ""
}

export function languageLevelListReducer(
  state: LanguageLevelListState = initialStateLanguageLevelList,
  action: memberActions,
): LanguageLevelListState {
  switch (action.type) {
    case GET_LANGUAGE_LEVEL_LİST_SUCCESS: {
      return {
        ...state,
        languageLevelList: action.payload,
      };
    }
    case GET_LANGUAGE_LEVEL_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Country List State and Reducer
interface CountryListState {
  countryList: CountryList[];
  message: string;
}

const initialStateCountryList: CountryListState = {
  countryList: [],
  message: "",
};

export function countryListReducer(
  state: CountryListState = initialStateCountryList,
  action: memberActions,
): CountryListState {
  switch (action.type) {
    case GET_COUNTRY_LİST_SUCCESS: {
      return {
        ...state,
        countryList: action.payload,
      };
    }
    case GET_COUNTRY_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// City List State and Reducer
interface CityListState {
  cityList: CityList[];
  message: string;
}

const initialStateCityList: CityListState = {
  cityList: [],
  message: "",
};

export function cityListReducer(
  state: CityListState = initialStateCityList,
  action: memberActions,
): CityListState {
  switch (action.type) {
    case GET_CITY_LİST_SUCCESS: {
      return {
        ...state,
        cityList: action.payload,
      };
    }
    case GET_CITY_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Town List State and Reducer
interface TownListState {
  townList: TownList[];
  message: string;
}

const initialStateTownList: TownListState = {
  townList: [],
  message: "",
};

export function townListReducer(
  state: TownListState = initialStateTownList,
  action: memberActions,
): TownListState {
  switch (action.type) {
    case GET_TOWN_LİST_BY_CITY_SUCCESS: {
      return {
        ...state,
        townList: action.payload,
      };
    }
    case GET_TOWN_LİST_BY_CITY_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Collage List State and Reducer
interface CollageListState {
  collageList: CollageList[];
  message: string;
}

const initialStateCollageList: CollageListState = {
  collageList: [],
  message: "",
};

export function collageListReducer(
  state: CollageListState = initialStateCollageList,
  action: memberActions,
): CollageListState {
  switch (action.type) {
    case GET_COLLAGE_LİST_SUCCESS: {
      return {
        ...state,
        collageList: action.payload,
      };
    }
    case GET_COLLAGE_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Department List State and Reducer
interface DepartmentListState {
  departmentList: DepartmentList[];
  message: string;
}

const initialStateDepartmentList: DepartmentListState = {
  departmentList: [],
  message: "",
};

export function departmentListReducer(
  state: DepartmentListState = initialStateDepartmentList,
  action: memberActions,
): DepartmentListState {
  switch (action.type) {
    case GET_DEPARTMENT_LİST_SUCCESS: {
      return {
        ...state,
        departmentList: action.payload,
      };
    }
    case GET_DEPARTMENT_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Personal Communication Level List State and Reducer
interface PersonalCommunicationLevelListState {
  personalCommunicationLevelList: PersonalCommunicationLevelList[];
  message: string
}

const initialStatePersonalCommunicationLevelList: PersonalCommunicationLevelListState = {
  personalCommunicationLevelList: [],
  message: ""
}

export function personalCommunicationLevelListReducer(
  state: PersonalCommunicationLevelListState = initialStatePersonalCommunicationLevelList,
  action: memberActions,
): PersonalCommunicationLevelListState {
  switch (action.type) {
    case GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS: {
      return {
        ...state,
        personalCommunicationLevelList: action.payload,
      };
    }
    case GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Graduation Status List State and Reducer
interface GraduationStatusListState {
  graduationStatusList: GraduationStatusList[];
  message: string
}

const initialStateGraduationStatusList: GraduationStatusListState = {
  graduationStatusList: [],
  message: ""
}

export function graduationStatusListReducer(
  state: GraduationStatusListState = initialStateGraduationStatusList,
  action: memberActions,
): GraduationStatusListState {
  switch (action.type) {
    case GET_GRADUATION_STATUS_LIST_SUCCESS: {
      return {
        ...state,
        graduationStatusList: action.payload,
      };
    }
    case GET_GRADUATION_STATUS_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Military Service Status List State and Reducer
interface MilitaryServiceStatusListState {
  militaryServiceStatusList: MilitaryServiceStatusList[];
  message: string
}

const initialStateMilitaryServiceStatusList: MilitaryServiceStatusListState = {
  militaryServiceStatusList: [],
  message: ""
}

export function militaryServiceStatusListReducer(
  state: MilitaryServiceStatusListState = initialStateMilitaryServiceStatusList,
  action: memberActions,
): MilitaryServiceStatusListState {
  switch (action.type) {
    case GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS: {
      return {
        ...state,
        militaryServiceStatusList: action.payload,
      };
    }
    case GET_MILITARY_SERVICE_STATUS_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Drivers License List State and Reducer
interface DriversLicenseListState {
  driversLicenseList: DriversLicenseList[];
  message: string
}

const initialStateDriversLicenseList: DriversLicenseListState = {
  driversLicenseList: [],
  message: ""
}

export function driversLicenseListReducer(
  state: DriversLicenseListState = initialStateDriversLicenseList,
  action: memberActions,
): DriversLicenseListState {
  switch (action.type) {
    case GET_DRIVERS_LICENSE_LIST_SUCCESS: {
      return {
        ...state,
        driversLicenseList: action.payload,
      };
    }
    case GET_DRIVERS_LICENSE_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Technic List State and Reducer
interface TechnicListState {
  technicList: TechnicList[];
  message: string;
}

const initialStateTechnicList: TechnicListState = {
  technicList: [],
  message: "",
};

export function technicListReducer(
  state: TechnicListState = initialStateTechnicList,
  action: memberActions,
) : TechnicListState {
  switch (action.type) {
    case GET_TECHNIC_LIST_SUCCESS: {
      return {
        ...state,
        technicList: action.payload,
      };
    }
    case GET_TECHNIC_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Personal Ability List State and Reducer
interface PersonalAbilityListState {
  personalAbilityList: PersonalAbilityList[];
  message: string
}

const initialStatePersonalAbilityList: PersonalAbilityListState = {
  personalAbilityList: [],
  message: ""
}

export function personalAbilityListReducer(
  state: PersonalAbilityListState = initialStatePersonalAbilityList,
  action: memberActions,
): PersonalAbilityListState {
  switch (action.type) {
    case GET_PERSONAL_ABİLİTY_LİST_SUCCESS: {
      return {
        ...state,
        personalAbilityList: action.payload,
      };
    }
    case GET_PERSONAL_ABİLİTY_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Communication Parameter List State and Reducer
interface CommunicationParameterListState {
  communicationParameterList: CommunicationParameterList[];
  message: string;
}

const initialStateCommunicationParameterList: CommunicationParameterListState = {
  communicationParameterList: [],
  message: "",
};

export function communicationParameterListReducer(
  state: CommunicationParameterListState = initialStateCommunicationParameterList,
  action: memberActions,
): CommunicationParameterListState {
  switch (action.type) {
    case GET_COMMUNICATION_PARAMETER_LIST_SUCCESS: {
      return {
        ...state,
        communicationParameterList: action.payload,
      };
    }
    case GET_COMMUNICATION_PARAMETER_LIST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}

// Language List State and Reducer — upstream 3d984c8.
// NOT: kayit redux/reducers/index.tsx'e yapilmali. Uygulamanin store'u
// src/index.tsx -> configureStore.tsx -> reducers/index.tsx zincirinden geliyor;
// src/redux/store.ts yalnizca RootState/AppDispatch tipleri icin import ediliyor,
// store ornegi hicbir yerde kullanilmiyor.
interface LanguageListState {
  languageList: LanguageList[];
  message: string;
}

const initialStateLanguageList: LanguageListState = {
  languageList: [],
  message: "",
};

export function languageListReducer(
  state: LanguageListState = initialStateLanguageList,
  action: memberActions,
): LanguageListState {
  switch (action.type) {
    case GET_LANGUAGE_LİST_SUCCESS: {
      return {
        ...state,
        languageList: action.payload,
      };
    }
    case GET_LANGUAGE_LİST_ERROR: {
      return {
        ...state,
        message: action.payload,
      };
    }
    default:
      return state;
  }
}
